import { getPatientAssignments } from "api/assignmentApi";
import { isEqual } from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { orgSelector, userSelector } from "redux/selectors";
import './assignmentsPage.scss'
import { initAssignment, initOrganization } from 'utils/initData';
import ActionTable from "components/table/actionTable";
import NoResult from "components/commonComponent/noResult";
import SpinnerComponent from "components/spinner";
import { assignmentStatus, pageCount, TypeAssignment } from "utils/constants";
import moment from "moment";
import SkillItem from "components/commonComponent/skillItem";
import { HiOutlineEye } from 'react-icons/hi'
import PaginateTable from "components/table/paginate";
import ReviewsOfAssignmentModal from "components/modal/reviewsOfAssignmentModal";
import AssignmentsEmpty from "components/empty/assignmentsEmpty";

const PlayIcon = require('../../../assets/image/svg/play-icon.svg').default
const PauseIcon = require('../../../assets/image/svg/pause-icon.svg').default

const PastAssignmentList = () => {
    const { userInfo } = useSelector(userSelector);
    const [currentAssignmentsData, setAssignmentsData] = useState<any>([])
    const [totalEntities, setTotalEntities] = useState(0);
    const [isShowNoAssignment, setIsShowNoAssignment] = useState(true)
    const [searchValue, setSearchValue] = useState('');
    const [isCollapse, setIsCollapse] = useState<any>({})
    const [currentPage, setCurrentPage] = useState(0);

    const [openListReviewModal, setOpenListReviewModal] = useState(false);
    const [targetAssignment, setTargetAssignment] = useState();
    const { organizationId } = useSelector(orgSelector);

    const [assignmentPlaying, setAssignmentPlaying] = useState<any>(null)
    const [audio, setAudio] = useState<any>(null)

    const clickOpenReviewListModal = (item: any) => {
        setTargetAssignment(item);
        setOpenListReviewModal(true);
    };

    const { data: pastAssignments, isLoading } = useQuery(['getPastAssignment', userInfo?.id, currentPage, searchValue, organizationId], () => getPatientAssignments(
        { page: currentPage, limit: pageCount, userId: userInfo?.id, searchQuery: searchValue, type: TypeAssignment.PAST }
    ),
        {
            retry: false,
            staleTime: Infinity,
            onSuccess: (data: any) => {
            },

        });
    const [t] = useTranslation()
    const handleCollapse = (id: string) => {
        const temp = {
            ...isCollapse,
            [id]: !isCollapse?.[id]
        }
        setIsCollapse(temp)
    }

    const handleSearch = (value: string) => {
        setSearchValue(value);
        setCurrentPage(0);
    };

    const handlePlay = async (e: any, assignment: any) => {
        e.stopPropagation();
        setAssignmentPlaying(assignment)
        if (audio) {
            audio.pause()
            setAudio(null)
        }
    }

    const handlePause = (e: any) => {
        e.stopPropagation();
        if (audio) {
            audio.pause()
            setAssignmentPlaying(null)
        }
    }

    useEffect(() => {
        audio?.addEventListener('ended', () => setAssignmentPlaying(null));
        return () => {
            audio?.removeEventListener('ended', () => setAssignmentPlaying(null));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps

    }, [audio, assignmentPlaying]);

    useEffect(() => {
        if (assignmentPlaying?.recording?.file?.url) {
            const audio = new Audio(assignmentPlaying?.recording?.file?.url)
            setAudio(audio)
            audio.play()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [assignmentPlaying])

    useEffect(() => {
        if (pastAssignments !== undefined) {
            // setAssignmentsData(assignments?.data?.entities);
            setAssignmentsData(pastAssignments.data.entities);

            setTotalEntities(pastAssignments?.data.totalEntities);
            if (pastAssignments?.data.entities.length > 0) {
                setIsShowNoAssignment(false)
            } else if (searchValue === '') setIsShowNoAssignment(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pastAssignments]);

    return (
        <div className="flex flex-col h-full">
            <div className="grow">
                {!isEqual(currentAssignmentsData[0], initAssignment) && totalEntities === 0 && currentAssignmentsData?.length === 0 && isShowNoAssignment && searchValue === '' && !isLoading ? (
                    <div className="px-5">
                        <AssignmentsEmpty title={t('titleYouAssignmentEmpty')} note={t('noteSlpAssignmentEmpty')} />
                    </div>

                ) : (
                    <div className='flex flex-col h-full organization-clinicians-container px-5'>
                        <div className="w-full organization-clinicians grow">
                            <div className='search-input'>
                                <ActionTable
                                    placeholderSearch="Search"
                                    buttonName="Add Assignment"
                                    searchValue={searchValue}
                                    setSearchValue={setSearchValue}
                                    handleSearch={handleSearch}
                                />
                            </div>
                            {!isEqual(currentAssignmentsData[0], initAssignment) && currentAssignmentsData.length === 0 && !isLoading && <NoResult />}
                            {!isEqual(currentAssignmentsData[0], initAssignment) && currentAssignmentsData.length > 0 && (
                                <div className="relative">
                                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400 pb-32 assignment-table-style">
                                        <thead className="text-xs border-b-2 text-on-primary-container dark:bg-gray-700 dark:text-gray-400">
                                            <tr className='w-full'>
                                                <th scope="col" className="font-medium py-3 px-4 w-1/5">
                                                    {t('assignment.prompt')}
                                                </th>
                                                <th scope="col" className="hidden-column-custom hidden-column font-medium  py-3 px-4 w-1/5">
                                                    {t('assignment.recorded')}
                                                </th>
                                                <th scope="col" className="hidden-column-custom  font-medium py-3 px-4 w-1/5">
                                                    {t('assignment.reviews')}
                                                </th>
                                                <th scope="col" className="font-medium py-3 px-4 w-1/5">
                                                    {t('assignment.status')}
                                                </th>
                                            </tr>
                                        </thead>
                                        {currentAssignmentsData.map((item: any, index: number) => {
                                            return (
                                                <>
                                                    <tr
                                                        onClick={() => clickOpenReviewListModal(item)}
                                                        key={`${item.id}-list-organization`}
                                                        className="border-b dark:bg-gray-800 dark:border-gray-700  hover:bg-hover-5 dark:hover:bg-gray-600"
                                                    >
                                                        <td className="w-1/5 py-2 px-4  font-medium text-on-primary-container dark:text-white cursor-pointer">
                                                            <div className="flex items-center">

                                                                {assignmentPlaying?.id !== item.id ? (<div className="bg-text-id flex items-center justify-center rounded-full min-w-9 h-9 w-9">
                                                                    <div onClick={(e) => handlePlay(e, item)} className="border border-2 border-circle-primary bg-white rounded-full min-w-30 h-30 w-30 flex items-center justify-center">
                                                                        <div style={{ marginLeft: '1px', marginBottom: '1px' }}>
                                                                            <img src={PlayIcon} alt="" />
                                                                        </div>
                                                                    </div>
                                                                </div>) : (<div onClick={(e) => handlePause(e)} className="bg-recording flex items-center justify-center rounded-full min-w-9 h-9 w-9">
                                                                    <div className="border border-2 border-circle-primary bg-white rounded-full min-w-30 h-30 w-30 flex items-center justify-center">
                                                                        <div style={{ marginLeft: '1px', marginBottom: '1px', width: '10px' }}>
                                                                            <img src={PauseIcon} alt="" />
                                                                        </div>
                                                                    </div>
                                                                </div>)}
                                                                <div className='text-on-primary-container flex flex-row items-center justify-center pl-2 '>
                                                                    <p className=''>
                                                                        {item?.prompt?.text}
                                                                    </p>
                                                                </div>
                                                            </div>

                                                        </td>
                                                        <td className=" w-1/5 hidden-column text-on-primary-container py-2 px-4">
                                                            {item?.recording?.created ? moment(item?.recording?.created).format('MMMM D, YYYY') : ''}
                                                        </td>
                                                        <td className=" w-1/5 hidden-column-custom text-on-primary-container py-2 px-4">
                                                            <div className="flex items-center">
                                                                <HiOutlineEye className="w-4 h-4 mr-2 " />
                                                                {item?.reviewers?.length}
                                                            </div>

                                                        </td>
                                                        <td className=" py-2 px-4 w-1/5 text-primary py-2 px-4">
                                                            {item.status === assignmentStatus.NOT_STARTED && (
                                                                <aside className="flex flex-row items-center">
                                                                    <span className="not-started-status w-2.5 h-2.5 flex  rounded-lg mr-2 " />
                                                                    <p className='not-started-status-text font-extralight'>
                                                                        {t('status.notStarted')}
                                                                    </p>
                                                                </aside>

                                                            )}
                                                            {item.status === assignmentStatus.COMPLETED && (
                                                                <aside className="flex flex-row items-center">
                                                                    <span className="completed-status w-2.5 h-2.5 flex  rounded-lg mr-2 " />
                                                                    <p className='completed-status-text font-extralight'>
                                                                        {t('status.completed')}
                                                                    </p>
                                                                </aside>
                                                            )}     {item.status === assignmentStatus.READY_FOR_REVIEW && (
                                                                <aside className="flex flex-row items-center">
                                                                    <span className="ready-for-review-status w-2.5 h-2.5 flex  rounded-lg mr-2 " />
                                                                    <p className='ready-for-review-status-text font-extralight'>
                                                                        {t('status.readyForReview')}
                                                                    </p>
                                                                </aside>
                                                            )}
                                                        </td>
                                                    </tr>
                                                </>
                                            );
                                        })}
                                    </table>
                                </div>
                            )}
                            {isLoading && !isEqual(currentAssignmentsData[0], initOrganization) && currentAssignmentsData?.length > 0 && <SpinnerComponent />}
                        </div>
                    </div>)}
            </div>
            {totalEntities > 0 && (
                <div className='px-5'>
                    <PaginateTable
                        setCurrentPage={setCurrentPage}
                        currentPage={currentPage}
                        totalEntities={totalEntities}
                    />
                </div>
            )}
            <ReviewsOfAssignmentModal openModal={openListReviewModal} setOpenModal={setOpenListReviewModal} targetData={targetAssignment} />

        </div>

    )
}
export default PastAssignmentList